export default __webpack_public_path__ + "6fac1e95535238bbdeed2c9921766a34.svg";